import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_ds_get_pick_tasks_by_licensePlateIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { licensePlateId?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LocationId?: number, LookupCode?: string, ShipmentId?: number, StatusId?: number, WarehouseId?: number, TasksForActualTargetLicensePlate?: { Id?: number, ActualPackagedAmount?: number, LotId?: number, MaterialId?: number, OrderId?: number, OrderLineNumber?: number, ShipmentId?: number, WarehouseId?: number, Lot?: { LookupCode?: string, ReceiveDate?: string, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string } }, Material?: { Id?: number, LookupCode?: string, Name?: string }, Order?: { LookupCode?: string, Project?: { LookupCode?: string, Name?: string } } }[], TasksForActualSourceLicensePlate?: { Id?: number, ActualPackagedAmount?: number, LotId?: number, MaterialId?: number, OrderId?: number, OrderLineNumber?: number, ShipmentId?: number, WarehouseId?: number, Lot?: { LookupCode?: string, ReceiveDate?: string, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string } }, Material?: { Id?: number, LookupCode?: string, Name?: string } }[], Location?: { Name?: string, Warehouse?: { Name?: string } }, Status?: { Name?: string } } }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      licensePlateId?: number    }) {
      return false;
    }
}
